import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "growthx_cookie_choice";

export const CookieBanner = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const choice = localStorage.getItem(STORAGE_KEY);
        if (!choice) setShow(true);
    }, []);

    const decide = (value) => {
        localStorage.setItem(STORAGE_KEY, value);
        setShow(false);
    };

    if (!show) return null;

    return (
        <div
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 bg-white border border-border rounded-xl shadow-lg p-4 md:p-5"
            data-testid="cookie-banner"
        >
            <p className="text-sm text-slate-700 leading-relaxed">
                We use minimal analytics to improve this page.{" "}
                <Link
                    to="/privacy"
                    className="underline text-primary font-medium"
                    data-testid="cookie-banner-privacy-link"
                >
                    Privacy
                </Link>
                .
            </p>
            <div className="mt-3 flex gap-2">
                <button
                    onClick={() => decide("declined")}
                    className="flex-1 text-sm font-medium px-3 py-2 rounded-md border border-border bg-white hover:bg-muted transition-colors"
                    data-testid="cookie-banner-decline"
                >
                    Decline
                </button>
                <button
                    onClick={() => decide("accepted")}
                    className="flex-1 text-sm font-medium px-3 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
                    data-testid="cookie-banner-accept"
                >
                    Accept
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
